import youtubeApi from './youtubeApi';

export const extractChannelId = async (url) => {
  try {
    // 프로토콜이 없으면 https://를 붙임
    if (!/^https?:\/\//i.test(url)) {
      url = 'https://' + url;
    }
    const urlObj = new URL(url);
    if (
      urlObj.hostname === "www.youtube.com" ||
      urlObj.hostname === "youtube.com"
    ) {
      // 채널 URL 형식에 따라 ID 추출
      if (urlObj.pathname.startsWith("/channel/")) {
        return urlObj.pathname.split("/")[2];
      } else if (
        urlObj.pathname.startsWith("/c/") ||
        urlObj.pathname.startsWith("/@")
      ) {
        // @핸들이나 /c/로 시작하는 경우 검색 API를 사용하여 실제 채널 ID를 가져옴
        const handle = decodeURIComponent(urlObj.pathname.split("/")[1]);
        const searchResponse = await youtubeApi.get("/search", {
          params: {
            part: "snippet",
            type: "channel",
            q: handle,
            maxResults: 1,
          },
        });

        if (!searchResponse.data.items?.length) {
          throw new Error("채널을 찾을 수 없습니다.");
        }

        return searchResponse.data.items[0].id.channelId;
      }
    }
    throw new Error("유효하지 않은 YouTube 채널 URL입니다.");
  } catch (error) {
    throw new Error("유효하지 않은 URL 형식입니다.");
  }
};

export const getChannelData = async (channelId) => {
  try {
    // 채널 상세 정보 가져오기
    const response = await youtubeApi.get("/channels", {
      params: {
        part: "snippet,statistics",
        id: channelId,
      },
    });

    if (!response.data.items?.length) {
      throw new Error("채널 정보를 찾을 수 없습니다.");
    }

    const channel = response.data.items[0];
    return {
      title: channel.snippet.title,
      thumbnails: channel.snippet.thumbnails.default.url,
      subscriberCount: parseInt(channel.statistics.subscriberCount),
      viewCount: parseInt(channel.statistics.viewCount),
      videoCount: parseInt(channel.statistics.videoCount),
    };
  } catch (error) {
    console.error("YouTube API Error:", error);
    throw new Error("채널 정보를 가져오는데 실패했습니다.");
  }
}; 